export default __webpack_public_path__ + "static/media/unify.b99ca8e8.svg";